/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V2beta1PluginState } from './V2beta1PluginState';
import {
  V2beta1PluginStateFromJSON,
  V2beta1PluginStateFromJSONTyped,
  V2beta1PluginStateToJSON,
  V2beta1PluginStateToJSONTyped,
} from './V2beta1PluginState';
import type { V2beta1MetadataValue } from './V2beta1MetadataValue';
import {
  V2beta1MetadataValueFromJSON,
  V2beta1MetadataValueFromJSONTyped,
  V2beta1MetadataValueToJSON,
  V2beta1MetadataValueToJSONTyped,
} from './V2beta1MetadataValue';

/**
 * Output from a single plugin, containing keyed metadata entries and overall state.
 * @export
 * @interface V2beta1PluginOutput
 */
export interface V2beta1PluginOutput {
  /**
   *
   * @type {{ [key: string]: V2beta1MetadataValue; }}
   * @memberof V2beta1PluginOutput
   */
  entries?: { [key: string]: V2beta1MetadataValue };
  /**
   *
   * @type {V2beta1PluginState}
   * @memberof V2beta1PluginOutput
   */
  state?: V2beta1PluginState;
  /**
   *
   * @type {string}
   * @memberof V2beta1PluginOutput
   */
  state_message?: string;
}

/**
 * Check if a given object implements the V2beta1PluginOutput interface.
 */
export function instanceOfV2beta1PluginOutput(value: object): value is V2beta1PluginOutput {
  return true;
}

export function V2beta1PluginOutputFromJSON(json: any): V2beta1PluginOutput {
  return V2beta1PluginOutputFromJSONTyped(json, false);
}

export function V2beta1PluginOutputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1PluginOutput {
  if (json == null) {
    return json;
  }
  return {
    entries:
      json['entries'] == null
        ? undefined
        : mapValues(json['entries'], V2beta1MetadataValueFromJSON),
    state: json['state'] == null ? undefined : V2beta1PluginStateFromJSON(json['state']),
    state_message: json['state_message'] == null ? undefined : json['state_message'],
  };
}

export function V2beta1PluginOutputToJSON(json: any): V2beta1PluginOutput {
  return V2beta1PluginOutputToJSONTyped(json, false);
}

export function V2beta1PluginOutputToJSONTyped(
  value?: V2beta1PluginOutput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    entries:
      value['entries'] == null
        ? undefined
        : mapValues(value['entries'], V2beta1MetadataValueToJSON),
    state: V2beta1PluginStateToJSON(value['state']),
    state_message: value['state_message'],
  };
}
